export const TEXT_FIELD_VALIDATION_EXCLUDED_CHARACTERS = ' \\  ? * < > | "';
export const TEXT_FIELD_TITLE_VALIDATION_EXCLUDED_CHARACTERS = ' \\ /  ? * < > | "';
export const TEXT_FIELD_VALIDATION_EXCLUDED_SPECIAL_CHARACTERS = ' \\  < >  "';

export const GET_USER_INFO_START = 'GET_USER_INFO_START';
export const GET_USER_INFO_SUCCESS = 'GET_USER_INFO_SUCCESS';
export const GET_USER_INFO_FAILURE = 'GET_USER_INFO_FAILURE';
